import { drawElementGroups } from "./drawElementGroups.js";
import { drawRect } from "./drawRect.js";
import { drawInteraction } from "./drawInteraction.js";
import { drawTrigger } from "./drawTrigger.js";
import { drawStartRole } from "./drawStartRole.js";
import { drawEllipsis } from "./drawEllipsis.js";
import { drawCaseRefinement } from "./drawCaseRefinement.js";
import { drawCaseCondition } from "./drawCaseCondition.js";
import { drawPartRefinement } from "./drawPartRefinement.js";
import { drawPartRepeat } from "./drawPartRepeat.js";
import { drawPartThread, drawPartRepeatThread } from "./drawPartThread.js";

const drawInteractionGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "activity-group interaction",
    drawFn: drawInteraction,
    onDrag,
    onClick,
  });
};

const drawActionGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "activity-group action",
    drawFn: drawRect,
    onDrag,
    onClick,
  });
};

const drawTriggerGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "activity-group trigger",
    drawFn: drawTrigger,
    onDrag,
    onClick,
  });
};

const drawStartRoleGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "activity-group start-role",
    drawFn: drawStartRole,
    onDrag,
    onClick,
  });
};

const drawEllipsisGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "activity-group ellipsis",
    drawFn: drawEllipsis,
    onDrag,
    onClick,
  });
};

const drawCaseRefinementGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "case-refinement-group refinement",
    drawFn: drawCaseRefinement,
    onDrag,
    onClick,
  });
};

const drawCaseConditionGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "condition subthread-group",
    drawFn: drawCaseCondition,
    onDrag,
    onClick,
  });
};

const drawPartRefinementGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "part-refinement-group refinement",
    drawFn: drawPartRefinement,
    onDrag,
    onClick,
  });
};

const drawPartRepeatGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "part-repeat-group refinement",
    drawFn: drawPartRepeat,
    onDrag,
    onClick,
  });
};

const drawPartThreadGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "part subthread-group",
    drawFn: drawPartThread,
    onDrag,
    onClick,
  });
};

const drawPartRepeatThreadGroups = (container, data, onDrag, onClick) => {
  drawElementGroups({
    container,
    data,
    classList: "repeat subthread-group",
    drawFn: drawPartRepeatThread,
    onDrag,
    onClick,
  });
};

export {
  drawInteractionGroups,
  drawActionGroups,
  drawTriggerGroups,
  drawStartRoleGroups,
  drawEllipsisGroups,
  drawCaseRefinementGroups,
  drawCaseConditionGroups,
  drawPartRefinementGroups,
  drawPartRepeatGroups,
  drawPartThreadGroups,
  drawPartRepeatThreadGroups,
};
